'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SliderConstants = exports.SLIDER_POPULAR = exports.SLIDER_HIT = exports.SLIDER_NEW = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SLIDER_NEW = exports.SLIDER_NEW = 1;
var SLIDER_HIT = exports.SLIDER_HIT = 2;
var SLIDER_POPULAR = exports.SLIDER_POPULAR = 3;

var SliderConstants = exports.SliderConstants = (0, _keymirror2.default)({
    SLIDER_LOAD: null,
    SLIDER_LOAD_CATEGORY: null,
    SLIDER_LOAD_SUCCESS: null,
    SLIDER_LOAD_CATEGORY_SUCCESS: null,
    SLIDER_LOAD_FAIL: null,
    SLIDER_LOAD_CATEGORY_FAIL: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/sliders.js
// module id = 261
// module chunks = 0